import React from 'react';
import { useAttrs, useCommands } from '@remirror/react';
import {
  Box,
  HStack,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '@cardboard-ui/react';
import {
  CloseCircleIcon,
  HighlighterIcon,
  SolidCircleIcon,
} from 'components/icons';
import { t } from '@lingui/macro';
import { useToolbarActive } from '../toolbar/tools/utils';
import { EditorToolBarButton } from '../toolbar/EditorToolBarButton';

const HIGHLIGHT_COLORS = () => [
  {
    name: t`Red`,
    rgb: 'rgba(255, 59, 59, 0.4)',
  },
  {
    name: t`Green`,
    rgb: 'rgba(144, 238, 144, 0.4)',
  },
  {
    name: t`Blue`,
    rgb: 'rgba(0, 255, 255, 0.4)',
  },
  {
    name: t`Yellow`,
    rgb: 'rgba(254 ,221 , 0, 0.4)',
  },
  {
    name: t`Pink`,
    rgb: 'rgba(255, 131, 150, 0.4)',
  },
  {
    name: t`Purple`,
    rgb: 'rgba(192, 174, 224, 0.4)',
  },
];

export function HighlightTool() {
  const commands = useCommands();
  const { formattingDisabled } = useToolbarActive();
  const highlight = (useAttrs().textHighlight()?.highlight as string) ?? '';
  const highLightColors = HIGHLIGHT_COLORS();
  const isHighlighted = highLightColors.some((c) => c.rgb === highlight);

  return (
    <Popover placement="top" autoFocus={false}>
      <PopoverTrigger>
        <Box>
          <EditorToolBarButton
            onClick={() => {}}
            selected={isHighlighted}
            isDisabled={formattingDisabled}
            size="xs"
          >
            <HighlighterIcon />
          </EditorToolBarButton>
        </Box>
      </PopoverTrigger>
      <PopoverContent width="auto">
        <PopoverArrow />
        <HStack spacing={0} p={1}>
          <IconButton
            aria-label={t`Remove highlight`}
            icon={<CloseCircleIcon size="lg" />}
            onClick={() => commands.removeTextHighlight()}
            size="xs"
            variant="ghost"
          />
          {highLightColors.map((color) => (
            <IconButton
              key={color.name}
              title={color.name}
              aria-label={t`Highlight color`}
              icon={<SolidCircleIcon size="lg" color={color.rgb} />}
              onClick={() => commands.setTextHighlight(color.rgb)}
              size="xs"
              variant="ghost"
            />
          ))}
        </HStack>
      </PopoverContent>
    </Popover>
  );
}
